module.exports = __webpack_public_path__ + "img/bg.d146aab5.jpg";